<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="formCard">
      <b-card-text>
        <b-row>
          <b-col md="6"
            ><h6>
              {{ $route.name }} - {{ form.enquiry_no }} - Booking NO -{{
                form.enquiry_booking_no
              }}
            </h6></b-col
          >
          <b-col md="6" class="text-right">
            <b-button @click="goBack" size="xxl" variant="outline-secondary">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button></b-col
          >
        </b-row>
        <hr />

        <b-row>
          <!-- {{form}} -->
          <b-col md="3">
            <label>ENQUIRY NO.<span class="error">*</span></label>
            <b-form-input :disabled="true" v-model="form.enquiry_no" required />
          </b-col>
          <b-col md="3">
            <label>
              Shipment Type
              <span class="error">*</span>
            </label>

            <model-list-select
              :list="shipment_typeList"
              id="shipment_type"
              :isDisabled="true"
              v-model="form.shipment_type"
              option-value="value"
              option-text="text"
              placeholder="Please Select Shipment Type"
              :style="{
                borderColor: !form.shipment_type && errorList.shipment_type ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.shipment_type">
              {{ errorList.shipment_type }}
            </span>
          </b-col>
          <b-col md="3">
            <label>
              Transport Type 
              <span class="error">*</span>
            </label>
            <model-list-select
              :list="moduelTypeList"
              :isDisabled="true"
              id="transport_type"
              v-model="form.transport_type"
              option-value="value"
              option-text="text"
              placeholder="Please Select Transport Type"
              :style="{
                borderColor:
                  !form.transport_type && errorList.transport_type ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.transport_type">
              {{ errorList.transport_type }}
            </span>
          </b-col>

          <b-col md="3">
            <label>INCO TERM SHIPMENT TERM<span class="error">*</span></label>
            <model-list-select
              :isDisabled="form.prbr_id>0"
              :list="deliveryTermsList"
              v-model="form.inco_term"
              option-value="value"
              option-text="text"
              placeholder="Select Incoterm"
              required
              :style="{
                borderColor: !form.inco_term && errorList.inco_term ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.inco_term">
              {{ errorList.inco_term }}
            </span>
          </b-col>

          <b-col md="3">
            <label>SHIPPER<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.fk_client_id || form.prbr_id>0
                  ? true
                  : false
              "
              :list="$store.getters['common/getAllClientList']"
              id="clientfilter"
              v-model="form.fk_client_id"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select SHIPPER"
              required
              :style="{
                borderColor: !form.fk_client_id && errorList.fk_client_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_client_id">
              {{ errorList.fk_client_id }}
            </span>
          </b-col>

          <b-col md="3">
             <!-- || form.fk_epk_id -->
                 
            <label>EMPTY PICK UP<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.prbr_id>0 ? true
                  : false
              "
              :list="
                form.transport_type == 'CRC'
                  ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                  : form.transport_type == 'Export'
                  ? $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList']
                  : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                    ]
              "
              v-model="form.fk_epk_id"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POR"
              :style="{
                borderColor: !form.fk_epk_id && errorList.fk_epk_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_epk_id">
              {{ errorList.fk_epk_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>HANDOVER<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.fk_por_id || form.prbr_id>0
                  ? true
                  : false
              "
              :list="
                form.transport_type == 'CRC'
                  ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                  : form.transport_type == 'Export'
                  ? $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList']
                  : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                    ]
              "
              v-model="form.fk_por_id"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POR"
              :style="{
                borderColor: !form.fk_por_id && errorList.fk_por_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_por_id">
              {{ errorList.fk_por_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>POL<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.fk_pol_id || form.prbr_id>0
                  ? true
                  : false
              "
              :list="
                form.transport_type == 'CRC'
                  ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                  : form.transport_type == 'Export'
                  ? $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList']
                  : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                    ]
              "
              v-model="form.fk_pol_id"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POL"
              :style="{
                borderColor: !form.fk_pol_id && errorList.fk_pol_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_pol_id">
              {{ errorList.fk_pol_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>POD<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.fk_pod_id || form.prbr_id>0
                  ? true
                  : false
              "
              :list="
                form.transport_type == 'CRC'
                  ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                  : form.transport_type == 'Export'
                  ? $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList']
                  : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                    ]
              "
              v-model="form.fk_pod_id"
              option-value="pickupId"
              option-text="location"
              placeholder="Select POD"
              :style="{
                borderColor: !form.fk_pod_id && errorList.fk_pod_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_pod_id">
              {{ errorList.fk_pod_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>FINAL DESTINATION<span class="error">*</span></label>
            <model-list-select
              :isDisabled="
                form.shipment_type == '' || form.transport_type == '' || form.fk_fpod_id || form.prbr_id>0
                  ? true
                  : false
              "
              :list="
                form.transport_type == 'CRC'
                  ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                  : form.transport_type == 'Export'
                  ? $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList']
                  : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                    ]
              "
              v-model="form.fk_fpod_id"
              option-value="pickupId"
              option-text="location"
              placeholder="Select POD"
              :style="{
                borderColor: !form.fk_fpod_id && errorList.fk_fpod_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_fpod_id">
              {{ errorList.fk_fpod_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>EQUIPMENT<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="$store.getters['common/getAllContainerTypeList']"
              v-model="form.fk_container_id"
              option-value="containerTypeId"
              option-text="containerType"
              placeholder="Select Container Type"
              :style="{
                borderColor:
                  !form.fk_container_id && errorList.fk_container_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_container_id">
              {{ errorList.fk_container_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label for="commodityType">Commodity Type<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="commodityTypeList"
              v-model="form.commodity_type"
              option-value="value"
              option-text="text"
              placeholder="Select Commodity Type"
              :style="{
                borderColor:
                  !form.commodity_type && errorList.commodity_type ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.commodity_type">
              {{ errorList.commodity_type }}
            </span>
          </b-col>

          <b-col md="3" v-if="form.commodity_type == 'Hazardous'">
            <label for="imdg_class">IMDG Class</label>
            <b-form-input
            :disabled="form.prbr_id>0"
              :formatter="capitalizeAll"
              id="imdg_class"
              name="imdg_class"
              v-model="form.imdg_class"
              :style="{
                borderColor: !form.imdg_class && errorList.imdg_class ? 'red' : '',
              }"
            ></b-form-input>
            <span class="error" v-if="!form.imdg_class">
              {{ errorList.imdg_class }}
            </span>
          </b-col>
          <b-col md="3" v-if="form.commodity_type == 'Hazardous'">
            <label for="un_number">UN Number</label>
            <b-form-input
            :disabled="form.prbr_id>0"
              :formatter="capitalizeAll"
              id="un_number"
              name="un_number"
              v-model="form.un_number"
              :style="{
                borderColor: !form.un_number && errorList.un_number ? 'red' : '',
              }"
            ></b-form-input>
            <span class="error" v-if="!form.un_number">
              {{ errorList.un_number }}
            </span>
          </b-col>
          <b-col md="3" v-if="form.commodity_type == 'Hazardous'">
            <label for="packing_code">Packing Code</label>
            <b-form-input
            :disabled="form.prbr_id>0"
              :formatter="capitalizeAll"
              id="packing_code"
              name="packing_code"
              v-model="form.packing_code"
              :style="{
                borderColor: !form.packing_code && errorList.packing_code ? 'red' : '',
              }"
            ></b-form-input>
            <span class="error" v-if="!form.packing_code">
              {{ errorList.packing_code }}
            </span>
          </b-col>
          <b-col md="3" v-if="form.commodity_type == 'Reefer'">
            <label for="temperature_required">Temperature Req(Degree Celsius)</label>
            <b-form-input
            :disabled="form.prbr_id>0"
              :formatter="capitalizeAll"
              id="temperature_required"
              name="temperature_required"
              v-model="form.temperature_required"
              :style="{
                borderColor:
                  !form.temperature_required && errorList.temperature_required
                    ? 'red'
                    : '',
              }"
            ></b-form-input>
            <span class="error" v-if="!form.temperature_required">
              {{ errorList.temperature_required }}
            </span>
          </b-col>
          <b-col md="3" v-if="form.commodity_type == 'Others'">
            <label for="other_comodity">Specific Detail if any..!</label>
            <b-form-input
            :disabled="form.prbr_id>0"
              :formatter="capitalizeAll"
              id="other_comodity"
              name="other_comodity"
              v-model="form.other_comodity"
              :style="{
                borderColor:
                  !form.other_comodity && errorList.other_comodity ? 'red' : '',
              }"
            ></b-form-input>
            <span class="error" v-if="!form.other_comodity">
              {{ errorList.other_comodity }}
            </span>
          </b-col>

          <b-col md="2">
            <label>COMMODITY & HS CODE<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              @searchchange="getCommodityList($event, 'getCommodityData')"
              :list="commodityList"
              v-model="form.fk_commodity_id"
              option-value="commodityId"
              option-text="itemHSNCode"
              placeholder="Select Commodity"
              :style="{
                borderColor:
                  !form.fk_commodity_id && errorList.fk_commodity_id ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.fk_commodity_id">
              {{ errorList.fk_commodity_id }}
            </span>
          </b-col>
          <b-col md="1">
            <b-button
              variant="primary"
              @click="openCommodityModal()"
              id="addButtonLoader"
              size="sm"
              style="margin-top: 40px"
              >Add</b-button
            >
          </b-col>

          <b-col md="3">
            <label>HUMIDITY (for reefer)<span class="error">*</span></label>
            <b-form-input
            :disabled="form.prbr_id>0"
              v-model="form.humidity"
              required
              :style="{
                borderColor: !form.humidity && errorList.humidity ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.humidity">
              {{ errorList.humidity }}
            </span>
          </b-col>

          <b-col md="3">
            <label>CARGO WEIGHT<span class="error">*</span></label>
            <b-form-input
            :disabled="form.prbr_id>0"
              v-model="form.cargo_weight"
              :style="{
                borderColor: !form.cargo_weight && errorList.cargo_weight ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.cargo_weight">
              {{ errorList.cargo_weight }}
            </span>
          </b-col>

          <b-col md="3">
            <label>SHIPPING LINE<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="$store.getters['common/getAllShippingLineList']"
              v-model="form.fk_shipping_id"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Shipping Line"
              :style="{
                borderColor:
                  !form.fk_shipping_id && errorList.fk_shipping_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_shipping_id">
              {{ errorList.fk_shipping_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>SPOT NON SPOT<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="spotList"
              option-value="value"
              option-text="text"
              v-model="form.spot_non_spot"
              placeholder="Select Spot Non-Spot"
              :style="{
                borderColor: !form.spot_non_spot && errorList.spot_non_spot ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.spot_non_spot">
              {{ errorList.spot_non_spot }}
            </span>
          </b-col>

          <b-col md="3">
            <label>RA NUMBER<span class="error">*</span></label>
            <b-form-input
            :disabled="form.prbr_id>0"
              type="text"
              v-model="form.ra_number"
              :style="{
                borderColor: !form.ra_number && errorList.ra_number ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.ra_number">
              {{ errorList.ra_number }}
            </span>
          </b-col>

          <b-col md="3">
            <label>RATE AGREED<span class="error">*</span></label>
            <b-form-input
            :disabled="form.prbr_id>0"
              type="number"
              v-model="form.rate_agreed"
              :style="{
                borderColor: !form.rate_agreed && errorList.rate_agreed ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.rate_agreed">
              {{ errorList.rate_agreed }}
            </span>
          </b-col>
          <b-col cols="3">
            <label>
              Currency
              <span class="error">*</span>
            </label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="$store.getters['common/getAllCurrencyList']"
              v-model="form.fk_currency_id"
              option-value="currency_id"
              option-text="currencyCode"
              placeholder="Select Currency"
              :style="{
                borderColor:
                  !form.fk_currency_id && errorList.fk_currency_id ? 'red' : '',
              }"
              @input="getCurrencyName(form.fk_currency_id)"
            ></model-list-select>
          
            <span class="error" v-if="!form.fk_currency_id">
              {{ errorList.fk_currency_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>FREE DAYS<span class="error">*</span></label>
            <b-form-input
             :disabled="form.prbr_id>0"
              type="text"
              v-model="form.free_days"
              :style="{
                borderColor: !form.free_days && errorList.free_days ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.free_days">
              {{ errorList.free_days }}
            </span>
          </b-col>

          <b-col md="3">
            <label>PDA<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="pdaList"
              option-value="value"
              option-text="text"
              v-model="form.pda"
              placeholder="Select PDA"
              :style="{
                borderColor: !form.pda && errorList.pda ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.pda">
              {{ errorList.pda }}
            </span>
          </b-col>

          <b-col md="3">
            <label>ETD<span class="error">*</span></label>
            <b-form-input
            :disabled="form.prbr_id>0"
              type="date"
              v-model="form.etd"
              :style="{
                borderColor: !form.etd && errorList.etd ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.etd">
              {{ errorList.etd }}
            </span>
          </b-col>

          <b-col md="3">
            <label>BL INSTRUCTION<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="blINSTRUCTIONList"
              option-value="value"
              option-text="text"
              v-model="form.bl_instruction"
              placeholder="Select BL INSTRUCTION"
              :style="{
                borderColor:
                  !form.bl_instruction && errorList.bl_instruction ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.bl_instruction">
              {{ errorList.bl_instruction }}
            </span>
          </b-col>

          <b-col md="3">
            <label>AGENT<span class="error">*</span></label>
            <model-list-select
            :isDisabled="form.prbr_id>0"
              :list="$store.getters['common/getAllAgentColoaderList']"
              option-value="agntColoaderId"
              option-text="agentName"
              v-model="form.fk_agent_id"
              placeholder="Select AGENT"
              :style="{
                borderColor: !form.fk_agent_id && errorList.fk_agent_id ? 'red' : '',
              }"
            ></model-list-select>
            <span class="error" v-if="!form.fk_agent_id">
              {{ errorList.fk_agent_id }}
            </span>
          </b-col>

          <b-col md="3">
            <label>REMARKS (if any)</label>
            <b-form-textarea v-model="form.remarks" :disabled="form.prbr_id>0" />
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col md="12" class="mx-auto text-center">
            <b-button @click="goBack" size="xxl" variant="outline-danger">
              Back
            </b-button>
            <b-button v-if="form.prbr_id<=0" @click="saveBookingResp" size="xxl" variant="outline-success">
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <!-- Commodity Modal Added By Priyanshu Singh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Commodity-modal"
      hide-footer
      title="Add Commodity"
    >
      <b-row class="justify-content-center">
        <b-col md="4">
          <label>Item Name <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="itemName"
            name="itemName"
            v-model="commodityModal.itemName"
            :style="{
              borderColor:
                !commodityModal.itemName && errorComodityList.itemName ? 'red' : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!commodityModal.itemName">{{
            errorComodityList.itemName
          }}</span>
        </b-col>
        <b-col md="4">
          <label>HSN Code <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="hsnCode"
            name="hsnCode"
            v-model="commodityModal.hsnCode"
            :style="{
              borderColor:
                !commodityModal.hsnCode && errorComodityList.hsnCode ? 'red' : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!commodityModal.hsnCode">{{
            errorComodityList.hsnCode
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            :disabled="commodityDisabled"
            variant="outline-primary"
            @click="addCommodity"
            id="addButtonLoader"
            size="sm"
            >Save</b-button
          >
          <b-button
            variant="outline-danger"
            class="ml-2"
            size="sm"
            @click="hideCommodityModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Commodity Modal Added By Priyanshu Singh Start -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import CustomLoader from "../common/customLoader.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import MasterService from "../../services/MasterService.js";
import { lastVisitPage, GlobalGetCommodity2 } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
export default {
  beforeMount() {
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePORDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineCrossCountryDDList",
      })
    );

    // Import DropDown Start
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPORDDList",
      })
    );
    let payload = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("edit_enq_price_id") != undefined &&
      this.$sessionsStorage.get("edit_enq_price_id") != null &&
      this.$sessionsStorage.get("edit_enq_price_id") != ""
    ) {
      this.getEnquiryPrcingList("Normal", this.$sessionsStorage.get("edit_enq_price_id"));
    }

    this.$store.dispatch("setCurrentRoute", "/pricing/upsertBookingResp");
    this.windowSize = $(window).width();
  },
  data() {
    return {
      // Added vy Priyanshu Singh Start
      commodityDisabled: false,
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: ["Please Enter ItemName", "Please Enter HSNCode"],
      errorComodityList: {
        itemName: "",
        hsnCode: "",
      },
      // Added vy Priyanshu Singh End

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "",
        ok: "ok",
      },

      formError: [
        // "Please Select Transport Type",
        // "Please Select Shipment Type",
        // "Please Select Client Name",
        // "Please Select Empty Pickup",
        // "Please Select Handover",
        // "Please Select POL",
        // "Please Select POD",
        // "Please Select FPOD",
        // "Please Select Currency",
        // "Please Select Equipment",
        // "Please Select Commodity Type",
        // "Please Select Commodity HSN CODE",
        // "Please Select Shipping Line",
        // "Please Select Agent",
      ],
      errorList: {
        // transport_type: "",
        // shipment_type: "",
        // fk_client_id: "",
        // fk_epk_id: "",
        // fk_por_id: "",
        // fk_pol_id: "",
        // fk_pod_id: "",
        // fk_fpod_id: "",
        // fk_currency_id: "",
        // fk_container_id: "",
        // commodity_type: "",
        // fk_commodity_id: "",
        // fk_shipping_id: "",
        // fk_agent_id: "",
      },
      form: {
        prbr_id: 0,
        enquiry_no: "",
        enquiry_booking_no: "",
        transport_type: "EXPORT",
        shipment_type: "Sea",
        inco_term: "",
        fk_client_id: "",
        fk_epk_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_fpod_id: "",
        fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
        fk_container_id: "",
        fk_currency_id: "1",
        commodity_type: "",
        fk_commodity_id: "",
        fk_shipping_id: "",
        fk_agent_id: "",
        other_comodity: "",
        packing_code: "",
        imdg_class: "",
        un_number: "",
        temperature_required: "",
        humidity: "",
        cargo_weight: "",
        spot_non_spot: "",
        ra_number: "",
        rate_agreed: "",
        free_days: "",
        pda: "",
        etd: "",
        bl_instruction: "",
        remarks: "",
      },
      blINSTRUCTIONList: [
        {
          text: "HOUSE BL",
          value: "HOUSE BL",
        },
        {
          text: "LINER BL",
          value: "LINER BL",
        },
        {
          text: "AS PER SHIPPER INSTRUCTION",
          value: "AS PER SHIPPER INSTRUCTION",
        },
      ],
      pdaList: [
        {
          text: "SHIPPER PDA",
          value: "SHIPPER PDA",
        },
        {
          text: "LINER PDA",
          value: "LINER PDA",
        },
        {
          text: "PRIDEL PDA",
          value: "PRIDEL PDA",
        },
        {
          text: "NOT APPLICABLE",
          value: "NOT APPLICABLE",
        },
      ],
      commodityTypeList: [
        {
          value: "Hazardous",
          text: "DANGEROUS CARGO (HAZ)",
        },
        {
          value: "Reefer",
          text: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          value: "Others",
          text: "GENERAL (OTHERS)",
        },
      ],
      spotList: [
        {
          value: "SPOT",
          text: "SPOT",
        },
        {
          value: "NON SPOT",
          text: "NON SPOT",
        },
      ],
      shipment_typeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      deliveryTermsList: [
        {
          value: "ExWorks",
          text: "EXWORKS",
        },
        {
          value: "FOB",
          text: "FOB",
        },
        {
          value: "CIF",
          text: "CIF",
        },
        {
          value: "DAP",
          text: "DAP",
        },
        {
          value: "DDU",
          text: "DDU",
        },
        {
          value: "DDP",
          text: "DDP",
        },
        {
          value: "CFR",
          text: "CFR",
        },
        {
          value: "FCA",
          text: "FCA",
        },
      ],
      getCommodityData: [],
      moduelTypeList: [
        {
          text: "EXPORT",
          value: "Export",
        },
        {
          text: "IMPORT",
          value: "Import",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      validate: true,
    };
  },
  created() {},
  mounted() {},
  computed: {
    commodityList() {
      return this.getCommodityData;
    },
  },

  destroyed() {},
  components: {
    ModelListSelect,
    MultiSelect,
    CustomLoader,
    Multiselect,
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    validateBookingResp() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.form[x] == "" || this.form[x] == undefined || this.form[x] == null) {
          this.errorList[x] = this.formError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    saveBookingResp() {
      this.validateBookingResp();
      if (this.validate) {
        this.isLoading = true;
        // Handle form submission
        this.form.fk_enq_price_id = this.$sessionsStorage.get("edit_enq_price_id");
        let payload = {
          itemCode: "upserEnqPricingBookingRes",
          itemDetails: this.form,
        };
        MasterService.getFreightEnqPriceing(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              // this.$refs["addPop"].open();
              this.goPricing();
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on saveBookingResp Error: ", error);
          });
      } else {
        // Show validation errors to the user
        console.log("Validation errors:", this.errorList);
      }
    },
    goPricing() {
      this.$router.push({
        path: "/enqPrice/enqPriceList",
      });
    },

    getEnquiryPrcingList(type, enq_price_id) {
      let payload = {
        itemCode: "Single_enq_price",
        enq_price_id: enq_price_id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.singleEnqPricing) {
              let enqPrice = data.singleEnqPricing;

              this.form.enquiry_no = enqPrice.enq_no;
              this.form.transport_type = enqPrice.transport_type;
              this.form.shipment_type = enqPrice.shipment_type;
              this.form.fk_client_id = enqPrice.fk_client_id;
              this.form.fk_epk_id = enqPrice.fk_emptyPL_id;
              this.form.fk_por_id = enqPrice.fk_por_id;
              this.form.fk_pol_id = enqPrice.fk_pol_id;
              this.form.fk_pod_id = enqPrice.fk_pod_id;
              this.form.fk_fpod_id = enqPrice.fk_fpod_id;
              this.form.fk_container_id = enqPrice.container_type_ids;
              this.form.fk_currency_id = "1";
              this.form.commodity_type = enqPrice.commodity_type;
              this.form.fk_shipping_id = enqPrice.fk_pre_shipping;
              this.form.remarks = enqPrice.remarks;
              let prbr_id =
                enqPrice.prbr_id && !isNaN(enqPrice.prbr_id)
                  ? parseInt(enqPrice.prbr_id)
                  : 0;

              if (prbr_id > 0) {
                this.getEnquiryPrcingBookingRespList(type, prbr_id);
              }
            }
            if (data.getCommodityData) {
              this.getCommodityData = data.getCommodityData;
            }
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    getEnquiryPrcingBookingRespList(type, prbr_id) {
      let payload = {};
      // if (type == "Normal") {
        this.isLoading = true;
      // }
      payload = {
        itemCode: "getEnqPricingBookingResList",
        type: type,
        DCfilterId: "",
        searchVal: "",
        DCfilterId: "",
        fromSearch: "",
        currentPage: "",
        perPage: "0",
        Filter: {},
        prbr_id: prbr_id,
      };
      MasterService.getFreightEnqPriceing(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.FrtEnqList.length > 0) {
              this.form = data.FrtEnqList[0];
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPrerequisiteList Error: ", error);
        });
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
      this.commodityDisabled = false;
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
      this.commodityDisabled = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorComodityList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorComodityList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getCurrencyName(fk_currency_id){
      let CurrencyArr = this.$store.getters['common/getAllCurrencyList'].filter(x => {
          return x.currency_id == fk_currency_id;
        });
      if(CurrencyArr.length>0){
        this.form.currency_name=CurrencyArr[0].currencyCode;
      }

    }, 
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        this.commodityDisabled = true;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              this.commodityDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>

<style>
body {
  background-color: #f8f9fa;
}

.b-container {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// addBookingResp.vue?29b6ee7a